<template lang="pug">
.status-dialogs.h-100.d-flex.flex-column.text-center
  .d-flex(style='margin-bottom: -48px;')
    button.transparent-button.ml-auto(@click='emitClose')
      i.fa.fa-times(style='font-size: 24px; padding: 12px 16px;')
  .mx-auto.my-auto.px-4.py-4.w-75
    img.mb-3(
      :src='selectedType.icon'
    )
    .text-large.mt-3(
      v-html='selectedType.title'
    )
      //- | คุณเสร็จสิ้นเปิดรายการขาย
    .text-medium.mt-3(
      v-html='selectedType.message'
    )
      //- | คุณทำรายการสั่งซื้อสำเร็จ ขณะนี้รายการของท่านอยู่ระหว่างขั้นตอนการอนุมัติ
      //- | ท่านสามารถบันทึกไฟล์รายการขายได้โดยกดปุ่มทำรายการด้านล่าง
    button.btn.btn-secondary.mt-4(@click='emitClose')
      | ปิด
</template>

<script>
/* eslint-disable global-require */
export default {
  props: {
    type: {
      default: 'cs.sellrecord.decline',
    },
  },
  computed: {
    selectedType() {
      return this.TYPES[this.type];
    },
  },
  data: () => ({
    TYPES: {
      'cs.sellrecord.reject': {
        icon: require('@/assets/_dialogs/icons/rejected.svg'),
        title: 'คุณยกเลิกรายการขายนี้แล้ว',
        // message: 'คุณทำรายการสั่งซื้อสำเร็จ ขณะนี้รายการของท่านอยู่ระหว่างขั้นตอนการอนุมัติ
        // ท่านสามารถบันทึกไฟล์รายการขายได้ โดยกดปุ่มทำรายการด้านล่าง',
      },
      'cs.sellrecord.approve': {
        icon: require('@/assets/_dialogs/icons/approved.svg'),
        title: 'คุณอนุมัติรายการขายนี้แล้ว',
      },
      'cs.sellrecord.approveforce': {
        icon: require('@/assets/_dialogs/icons/approved.svg'),
        title: 'คุณอนุมัติรายการขายบางส่วนแล้วนี้แล้ว กรุณาตรวจสอบรายการขายอีกครั้งเพื่อดูจำนวนสินค้าที่เปิดจริง',
      },
      'admin.entryDetail.approveforce': {
        icon: require('@/assets/_dialogs/icons/approved.svg'),
        title: 'คุณอนุมัติรายการขายบางส่วนแล้วนี้แล้ว กรุณาตรวจสอบรายการขายอีกครั้งเพื่อดูจำนวนสินค้าที่เปิดจริง',
      },
      'cs.sellrecord.admin': {
        icon: require('@/assets/_dialogs/icons/admin.svg'),
        title: 'คุณส่งรายการนี้ไปให้ admin แล้ว',
      },
      'admin.entryDetail.reject': {
        icon: require('@/assets/_dialogs/icons/rejected.svg'),
        title: 'คุณยกเลิกรายการขายนี้แล้ว',
      },
      'admin.entryDetail.approve': {
        icon: require('@/assets/_dialogs/icons/approved.svg'),
        title: 'คุณอนุมัติรายการขายนี้แล้ว',
      },
      'admin.entryDetail.cs': {
        icon: require('@/assets/_dialogs/icons/approved.svg'),
        title: 'คุณส่งรายการนี้กลับไปยัง CS แล้ว',
      },
    },
  }),
  methods: {
    emitClose() {
      this.$emit('closeButtonClicked');
    },
  },
};
</script>

<style lang="scss">
// .status-dialogs { }
</style>
